const numberFormatter =
  typeof Intl !== "undefined"
    ? new Intl.NumberFormat("no-NB", {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    : undefined;

const currencyFormatter =
  typeof Intl !== "undefined"
    ? new Intl.NumberFormat("no-NB", {
        style: "currency",
        currency: "NOK",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    : undefined;

export function formatNumber(number: number): string {
  return numberFormatter ? numberFormatter.format(number) : `${number}`;
}

export function formatCurrency(price: number): string {
  return currencyFormatter ? currencyFormatter.format(price) : `${price}`;
}

export function formatDate(date: Date | string) {
  const d = new Date(date);
  const formattedDate = d
    .toLocaleDateString("nb-NO", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, ".");

  return formattedDate;
}
